module.exports = __webpack_public_path__ + "img/q5.c71915aa.svg";